import * as THREE from 'three';
import $ from 'jquery';
import {$win} from '../common';
import bezier from 'bezier-easing';
import orbitInit from './vendor/three-orbit-control';

export default function Models(canvasSelector, orbitListenerSelector) {
    'use strict';

    //@TODO rename private vars to _
    let _this = this;
    let options = new function() {
        this.clearColor = 0x304ffe;
        this.particlesSize = 0.5;
        this.particlesColor = 0x222222;
        this.particlesCount = 50000;
    };
    let camera, scene, renderer;
    let $container, orbit;



    const EXPLOSION_SIZE = 170;
    const _modelList = {
        koleso: 'models/koleso.json?v2',
        shlem: 'models/shlem.json?v2',
        remen: 'models/remen.json?v2',
        list: 'models/list.json?v2',
        kitchen: 'models/kitchen.json?v2',
        // banka: 'models/banka.json?v2',
    };
    const _modelListKeys = Object.keys(_modelList);
    let _currentModelName = _modelListKeys[0];
    let _verticesData = {};



     function initModels() {
        getJSON(_currentModelName).then((result) => {
            _this.particleCloud = createParticleCloud(result);
            //console.log(_this.particleCloud);
            scene.add(_this.particleCloud);
        });
    }

    const CHANGE_MODEL_DURATION = 800;
    function changeModel(modelName) {
        if (!modelName || !_this.particleCloud) {
            return;
        }

        return new Promise(function (resolve, reject) {
            _currentModelName = modelName;
            let explodePromise = _explodeParticles();
            let jsonPromise = getJSON(modelName);

            Promise.all([jsonPromise, explodePromise]).then((results) => {
                // remove old
                scene.remove(_this.particleCloud);
                // add new
                _this.particleCloud = createParticleCloud(results[0]);
                scene.add(_this.particleCloud);
                _implodeParticles().then(resolve);
            });
        });
    }

    this.next = function () {
        let currentIndex = _modelListKeys.indexOf(_currentModelName);
        let newIndex = currentIndex + 1;
        if (newIndex >= _modelListKeys.length) {
            newIndex = 0;
        }
        changeModel(_modelListKeys[newIndex]);
    };

    this.prev = function () {
        let currentIndex = _modelListKeys.indexOf(_currentModelName);
        let newIndex = currentIndex - 1;
        if (newIndex < 0) {
            newIndex = _modelListKeys.length - 1;
        }
        changeModel(_modelListKeys[newIndex]);
    };

    this.setModel = function(newIndex) {
      return changeModel(_modelListKeys[newIndex])
    };



    /**
     * Add explosion positions if needed
     * @param {Integer} length
     */
    let explosionPositions = [];
    function addExplosionPositions(length) {
        if (explosionPositions.length < length) {
            for (let i = explosionPositions.length; i < length; i++) {
                let angle = 2 * Math.PI * Math.random();
                let u = Math.random() + Math.random();
                let radius = u > 1 ? 2 - u : u;
                explosionPositions.push(new THREE.Vector3(
                    radius * Math.sin(angle) * EXPLOSION_SIZE / 2,
                    radius * Math.cos(angle) * EXPLOSION_SIZE / 2,
                    (Math.random() - 0.5) * EXPLOSION_SIZE
                ));
            }
        }
    }

    let easingOut = bezier(0.5, 0, 0.1, 1);
    let easingInside = bezier(0.55, 0, 0.5, 1);

    /**
     * Explode particleCloud to explosionPositions sphere
     * @returns {Promise}
     * @private
     */
    function _explodeParticles() {
        addExplosionPositions(_this.particleCloud.geometry.vertices.length);
        let originalMeshPositions = [];
        // save original particleCloud positions to another array
        for (let i = 0; i < _this.particleCloud.geometry.vertices.length; i++) {
            originalMeshPositions[i] = _this.particleCloud.geometry.vertices[i].clone();
        }

        return _tween(easingOut, CHANGE_MODEL_DURATION)(_transformParticles, originalMeshPositions, explosionPositions);
    }

    /**
     * Implode particleCloud from explosionPositions sphere
     * @returns {Promise}
     * @private
     */
    function _implodeParticles() {
        addExplosionPositions(_this.particleCloud.geometry.vertices.length);
        let originalMeshPositions = [];
        for (let i = 0; i < _this.particleCloud.geometry.vertices.length; i++) {
            // save original particleCloud positions to another array
            originalMeshPositions[i] = _this.particleCloud.geometry.vertices[i].clone();
            // set particleCloud positions to explosionPositions
            _this.particleCloud.geometry.vertices[i].copy(explosionPositions[i]);
        }

        return _tween(easingInside, CHANGE_MODEL_DURATION)(_transformParticles, explosionPositions, originalMeshPositions);
    }

    /**
     *
     * @param {Float32Array} streamPositions32Array
     * @param {Number} streamPositionsRotation in radian
     * @param {Integer} duration in milliseconds
     * @returns {Promise}
     */
    this.implodeParticlesFromStream = function (streamPositions32Array, streamPositionsRotation, duration) {
        let preparedData = _prepareToStreamTransform(streamPositions32Array, streamPositionsRotation);
        let tween = _tween(easingInside, duration);
        tween(_transformMaterialSize, 0.9, options.particlesSize);
        tween(_transformOrbitScale, 0, 1);
        return tween(_transformParticles, preparedData.streamPositions, preparedData.originalMeshPositions);
    };

    /**
     * Explode particleCloud to stream and then set initial values
     * @param {Float32Array} streamPositions32Array
     * @param {Number} streamPositionsRotation in radian
     * @param {Integer} duration in milliseconds
     * @returns {Promise}
     */
    this.explodeParticlesToStream = function (streamPositions32Array, streamPositionsRotation, duration) {
        let preparedData = _prepareToStreamTransform(streamPositions32Array, streamPositionsRotation);
        let tween = _tween(easingOut, duration);
        tween(_transformMaterialSize, options.particlesSize, 0.9).then(() => {
            _this.particleCloud.material.size = options.particlesSize;
        });
        tween(_transformOrbitScale, 1, 0).then(() => {
            orbit.rotationScale = 1;
        });
        return tween(_transformParticles, preparedData.originalMeshPositions, preparedData.streamPositions).then(() => {
            // restore particleCloud to original positions
            for (let i = 0; i < _this.particleCloud.geometry.vertices.length; i++) {
                _this.particleCloud.geometry.vertices[i] = preparedData.originalMeshPositions[i].clone();
            }
        });
    };

    /**
     * tween factory
     * @param {bezier|Function} easingFunction
     * @param {Integer} duration in milliseconds
     */
    function _tween(easingFunction, duration) {

        /**
         * @param {Function} transformation
         * @param fromValue
         * @param toValue
         * @returns {Promise}
         */
        return function (transformation, fromValue, toValue) {
            let startTime;

            return new Promise(function (resolve, reject) {
                startTime = Date.now();
                transformStep();

                // explosion animation
                function transformStep() {
                    let deltaTime = (Date.now() - startTime) / duration;
                    let shouldResolve;
                    if (deltaTime > 1) {
                        deltaTime = 1;
                        shouldResolve = true;
                    }
                    let deltaDistance = easingFunction(deltaTime);

                    transformation(fromValue, toValue, deltaDistance);

                    if (shouldResolve) {
                        resolve();
                    } else {
                        window.requestAnimationFrame(transformStep);
                    }
                }
            });
        };
    }

    /**
     * Transform particleCloud.geometry from one points array to another over duration with easingFunction
     * @param {Points|Array} fromPositions
     * @param {Points|Array} toPositions
     * @param {Number} deltaDistance - 0 to 1 returned from easing function
     * @private
     */
    function _transformParticles(fromPositions, toPositions, deltaDistance) {
        // move particles from meshPositions to explosionPositions by easing function
        for (let i = 0; i < _this.particleCloud.geometry.vertices.length; i++) {
            _this.particleCloud.geometry.vertices[i].set(
                fromPositions[i].x + (toPositions[i].x - fromPositions[i].x) * deltaDistance,
                fromPositions[i].y + (toPositions[i].y - fromPositions[i].y) * deltaDistance,
                fromPositions[i].z + (toPositions[i].z - fromPositions[i].z) * deltaDistance
            )
        }
        _this.particleCloud.geometry.verticesNeedUpdate = true;
    }

    /**
     * Transform particles size
     * @param {Number} fromSize
     * @param {Number} toSize
     * @param {Number} deltaDistance
     * @private
     */
    function _transformMaterialSize(fromSize, toSize, deltaDistance) {
        _this.particleCloud.material.size = fromSize + (toSize - fromSize) * deltaDistance;
    }

    /**
     * Transform orbit rotation scale
     * @param {Number} fromScale
     * @param {Number} toScale
     * @param {Number} deltaDistance
     * @private
     */
    function _transformOrbitScale(fromScale, toScale, deltaDistance) {
        orbit.rotateScale = fromScale + (toScale - fromScale) * deltaDistance;
        orbit.update();
    }

    /**
     *
     * @param {Float32Array} streamPositions32Array
     * @param {Number} streamPositionsRotation in radian
     * @returns {{originalMeshPositions: Array, streamPositions: Array}}
     * @private
     */
    function _prepareToStreamTransform(streamPositions32Array, streamPositionsRotation) {
        let originalMeshPositions = [];
        let streamPositions = [];
        const yAxis = new THREE.Vector3(0, 1, 0);

        for (let i = 0; i < _this.particleCloud.geometry.vertices.length; i++) {
            // save original particleCloud positions to another array
            originalMeshPositions[i] = _this.particleCloud.geometry.vertices[i].clone();
            // make streamPositions Array from Float32Array
            let offset = i * 3 % streamPositions32Array.length;
            streamPositions.push(new THREE.Vector3(
                // деление на 10, потому что камера у моделей в 10 раз ближе чем у потока (150 и 1500)
                streamPositions32Array[offset] / 10,
                streamPositions32Array[offset + 1] / 10,
                streamPositions32Array[offset + 2] / 10
            ));
            streamPositions[i].applyAxisAngle(yAxis, streamPositionsRotation)
        }

        return {originalMeshPositions, streamPositions};
    }




    /**
     * Generate circle texture on canvas
     * @return {Texture}
     */
    function generateTexture() {
        let canvas = document.createElement('canvas');
        canvas.width = 2048;
        canvas.height = 2048;
        let ctx = canvas.getContext('2d');
        ctx.beginPath();
        ctx.arc(1024,1024,1024,0,2*Math.PI);
        ctx.fill();

        let texture = new THREE.Texture(canvas);
        texture.needsUpdate = true;

        return texture;
    }

    /**
     * Create particle cloud Mesh from Geometry
     * @param {Array} verticesData
     * @returns {Points}
     */
    function createParticleCloud(verticesData) {
        let geometry = new THREE.Geometry();
        for (let i = 0; i < verticesData.length; i+=3) {
            geometry.vertices.push(new THREE.Vector3(verticesData[i], verticesData[i + 1], verticesData[i + 2]))
        }
        let material = new THREE.PointsMaterial({
            color: options.particlesColor,
            size: options.particlesSize,
            transparent: true,
            alphaTest: 0.5,
            depthTest: false,
            depthWrite: false,
            map: generateTexture(),
        });

        let particleCloud = new THREE.Points(geometry, material);
        particleCloud.sortParticles = true;

        return particleCloud;
    }


    /**
     * Load model's json by name from this.modelList
     * @param {String} modelName
     * @return {Promise}
     */
    function getJSON(modelName) {
        return new Promise(function (resolve, reject) {

            if (_verticesData[modelName]) {
                resolve(_verticesData[modelName]);
            } else {
                $.get({
                    url: _modelList[modelName],
                    dataType: 'json',
                    success(data) {
                        _verticesData[modelName] = data;
                        resolve(data);
                    }
                });
            }
        });
    }

    function tryPreloadModel() {
        _modelListKeys.some((modelName) => {
            if (!_verticesData[modelName]) {
                getJSON(modelName).then(tryPreloadModel);
                return true;
            }
        });
    }
    this.startPreloadModels = tryPreloadModel;


    let resolveRenderPromise;
    this.waitForRender = function () {
        return new Promise(function (resolve, reject) {
            resolveRenderPromise = resolve;
        })
    };




    initBase();
    initModels();


    function initBase() {
        $container = $(canvasSelector);
        camera = new THREE.PerspectiveCamera(60, $container.outerWidth() / $container.outerHeight(), 5, 15000);
        camera.position.z = 150;
        camera.position.x = -0.04 * $container.outerWidth();
        scene = new THREE.Scene();
        scene.fog = new THREE.Fog(options.clearColor, 1000, 10000);
        //
        renderer = new THREE.WebGLRenderer({antialias: true, logarithmicDepthBuffer: true});
        renderer.setClearColor(options.clearColor);
        renderer.setPixelRatio(window.devicePixelRatio);
        renderer.setSize($container.outerWidth(), $container.outerHeight());
        $container[0].appendChild(renderer.domElement);
        //
        let OrbitControls = orbitInit(THREE);
        orbit = new OrbitControls(camera, $(orbitListenerSelector)[0]);
        orbit.minPolarAngle = -0.3; // radians
        orbit.maxPolarAngle = 0.3; // radians
        orbit.minAzimuthAngle = -0.3; // radians
        orbit.maxAzimuthAngle = 0.3; // radians
        orbit.rotateSpeed = 0.03;
        //
        $win.on('resize fullpage_resized', function () {
            camera.aspect = $container.outerWidth() / $container.outerHeight();
            camera.updateProjectionMatrix();
            renderer.setSize($container.outerWidth(), $container.outerHeight());
        });
    }


    let animating = 0;
    this.play = function () {
        // cant start if already playing
        if (animating) {
            return;
        }
        animating = true;
        animate();
    };
    this.stop = function () {
        window.cancelAnimationFrame(animating);
        animating = null;
    };
    function animate() {
        if (!animating) {
            return;
        }
        renderer.render(scene, camera);
        if (typeof resolveRenderPromise === 'function') {
            resolveRenderPromise();
            resolveRenderPromise = null;
        }
        animating = window.requestAnimationFrame(animate);
    }


}



// WEBPACK FOOTER //
// ./scripts/three-models.js